import React from "react";

const LINK_STYLE = {
  color: "#1D9E75",
  textDecoration: "underline",
  wordBreak: "break-all",
};

/** Split trailing punctuation that is not part of the URL (e.g. "https://x.nz/."). */
function splitUrlPart(part) {
  const match = part.match(/^(https?:\/\/[^\s]+?)([.,;:!?)]+)?$/);
  if (!match) {
    return { href: part, display: part, suffix: "" };
  }
  return {
    href: match[1],
    display: match[1],
    suffix: match[2] ?? "",
  };
}

function renderInlinePart(part, key) {
  if (part.startsWith("**") && part.endsWith("**")) {
    return <strong key={key}>{part.slice(2, -2)}</strong>;
  }

  if (part.startsWith("http://") || part.startsWith("https://")) {
    const { href, display, suffix } = splitUrlPart(part);
    return (
      <React.Fragment key={key}>
        <a href={href} target="_blank" rel="noopener noreferrer" style={LINK_STYLE}>
          {display}
        </a>
        {suffix}
      </React.Fragment>
    );
  }

  return part;
}

function renderContent(content) {
  const lines = String(content ?? "").split("\n");
  return lines.map((line, i) => {
    const parts = line.split(/(\*\*[^*]+\*\*|https?:\/\/[^\s]+)/g);
    const rendered = parts.filter(Boolean).map((part, j) => renderInlinePart(part, j));

    return (
      <React.Fragment key={i}>
        {rendered}
        {i < lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
}

export default function ChatMessageBubble({ message }) {
  const isUser = message?.role === "user";
  const ts = message?.timestamp instanceof Date ? message.timestamp : new Date(message?.timestamp ?? Date.now());
  const timeString = ts.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  return (
    <div className={`chat-message ${isUser ? "chat-message--user" : "chat-message--assistant"}`}>
      {!isUser && (
        <div className="chat-message__avatar" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z" />
          </svg>
        </div>
      )}

      <div className="chat-message__content-wrap">
        <div className="chat-message__bubble">{renderContent(message?.content)}</div>

        {message?.ticketCreated && message?.ticketId && (
          <div className="chat-message__ticket-badge">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 2.5c.83 0 1.5.67 1.5 1.5S15.83 9.5 15 9.5 13.5 8.83 13.5 8s.67-1.5 1.5-1.5zm0 5c-1.67 0-5 .83-5 2.5V15h10v-.5c0-1.67-3.33-2.5-5-2.5z" />
            </svg>
            Ticket #{String(message.ticketId).slice(0, 8)} created
          </div>
        )}

        <div className="chat-message__time">{timeString}</div>
      </div>
    </div>
  );
}

